export default {"src":"/_next/static/media/betfounders.3073f55d.svg","height":39,"width":272};